let RepAI = typeof window !== 'undefined' ? window.RepAI : undefined;
const methods = [
    'init',
    'identify',
    'dial',
    'alert',
    'bookMeeting',
    'hide',
    'show',
    'expand',
    'collapse',
    'connect',
    'disconnect',
    'startJourney',
];
function throwIfNotBrowser() {
    if (typeof window === 'undefined') {
        throw new Error('RepAI methods can only be called in a browser context.');
    }
}
if (!RepAI) {
    const callMethod = function (m, args) {
        throwIfNotBrowser();
        // If window.RepAI has been replaced, call that instead
        if (window.RepAI && window.RepAI !== sb) {
            return window.RepAI(m, ...args);
        }
        // Otherwise push to the temporary queue
        sb.q.push([m, [...args]]);
    };
    // Create the dummy module
    const sb = function (m, ...args) {
        return callMethod(m, args);
    };
    sb.q = [];
    // Stub out named methods
    methods.forEach(m => {
        sb[m] = function (...args) {
            return callMethod(m, args);
        };
    });
    RepAI = sb;
    if (typeof window !== 'undefined') {
        window.RepAI = sb;
    }
    // Load the script, if we haven't already
    if (typeof document !== 'undefined' && !document.getElementById('rep-ai-script')) {
        const scriptEl = document.createElement('script');
        scriptEl.id = 'rep-ai-script';
        scriptEl.src = 'https://cdn.rep.ai/main.js';
        scriptEl.type = 'text/javascript';
        scriptEl.async = true;
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(scriptEl, firstScript);
        }
        else {
            document.head.appendChild(scriptEl);
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
var RepAI$1 = RepAI;

export default RepAI$1;
